import { useState } from 'react';
import { Card } from '@/components/ui/Card';
import { ExportPanel, FinanceReport } from '@/features/shared/reports/SchoolReports';
import { DataTable, DateInput, Filters, Notice, PageHeader, Stat, arr, errMsg, money, useGet } from '@/features/shared/ops/kit';

const monthStart = () => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1, 12).toISOString().slice(0, 10); };
const todayStr = () => new Date().toISOString().slice(0, 10);

export function ReportsPage() {
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(todayStr());
  const pnl = useGet<any>('rep-pnl', '/school/books/profit-loss', { from, to });
  const pay = useGet<any>('rep-methods', '/school/payments', { status: 'successful', from, to, per_page: 100 });

  const byMethod = arr(pay.data).reduce((m: Record<string, number>, p: any) => { m[p.method] = (m[p.method] ?? 0) + Number(p.amount ?? 0); return m; }, {});
  const d = pnl.data;
  const rate = d && Number(d.fees_billed) > 0 ? Math.round((Number(d.fees_collected) / Number(d.fees_billed)) * 100) : null;

  return (
    <div>
      <PageHeader
        title="Reports"
        sub="Finance summaries for the chosen period"
      />
      <Filters><DateInput label="From" value={from} onChange={setFrom} /><DateInput label="To" value={to} onChange={setTo} /></Filters>
      <div className="space-y-4">
        <Card title="Profit & loss">
          {pnl.isLoading && <p className="text-sm text-slate-500">Loading…</p>}
          {pnl.error && <Notice kind="error">{errMsg(pnl.error)}</Notice>}
          {d && (
            <div className="space-y-3">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                <Stat label="Fees billed" value={money(d.fees_billed)} />
                <Stat label="Fees collected" value={money(d.fees_collected)} sub={rate != null ? `${rate}% of billed` : undefined} />
                <Stat label="Expenses" value={money(d.expenses)} />
                <Stat label="Net" value={money(d.net)} />
              </div>
              <DataTable rows={arr(d.expenses_by_category)} empty="No approved expenses in this period." cols={[{ head: 'Expense category', cell: (r: any) => r.category }, { head: 'Total', right: true, cell: (r: any) => money(r.total) }]} />
            </div>
          )}
        </Card>
        <Card title="Collections by method">
          {pay.isLoading ? <p className="text-sm text-slate-500">Loading…</p> : pay.error ? <Notice kind="error">{errMsg(pay.error)}</Notice> : (
            <DataTable rows={Object.entries(byMethod)} empty="No successful payments in this period." cols={[{ head: 'Method', cell: ([m]: any) => m }, { head: 'Total', right: true, cell: ([, t]: any) => money(t) }]} />
          )}
        </Card>
        <FinanceReport />
        <ExportPanel only={['finance', 'payments', 'debtors', 'students']} />
      </div>
    </div>
  );
}
